import axios from 'axios';

// Public program availability is confirmed by the authenticated backend.
export async function canAccessNutrable() {
  try {
    const { data } = await axios.get(`${process.env.VUE_APP_API_URL}/api/nutrable/access`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        cid: localStorage.getItem('cid'),
      },
    });
    return data.available === true;
  } catch {
    return false;
  }
}
